module.exports = __webpack_public_path__ + "img/centrum-placemat-mockup.2a1e2dd3.jpg";